import Store from 'src/store';
export default function getLocalEntityState(localEntity) {
    return Store.state[localEntity];
}
